import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import DeleteIcon from "../../../Assets/Images/CommanImages/new_delete_icon.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SuccessImg from "./../../../Assets/Images/CommanImages/success.png";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL } from "../../../Config/Config";
import "./questiondashborad.css";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  dataClient,
  setPagePath,
  renderQuestionText,
  setId,
  renderQuestionTextModel,
  toggleImage,
  expandedStates,
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setData,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const [filterRunTime, setFilterRunTime] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const isAllSelected = selectedRows.length === data.length;
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
  const columnDropdownRef = useRef(null);

  useEffect(() => {
    setVisibleColumns(headers.slice(0, 6));
  }, [headers]);

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const accessToken = localStorage.getItem("other");
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const handleColumnSelection = (column) => {
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterRunTimeChange = (e) => {
    setFilterRunTime(e.target.value);
  };

  const handleApplyFilter = () => {
    setAverageRunTime(filterRunTime);
    setIsFilterVisible(false); // Close the modal
    setCurrentPage(1); // Reset to the first page on filter
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;
    return matchesSearchQuery && matchesAverageRunTime;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");

    if (!fileName) {
      return;
    }

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([
        visibleColumns,
        ...exportData,
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });

      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1); // Reset to the first page
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((_, index) => index));
      console.log(
        "Selected Question IDs:",
        data.map((row) => row[7])
      );
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((row) => row !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
      console.log("Selected Question ID:", data[index][7]);
    }
  };

  const handleDeleteClick = async () => {
    if (selectedRows.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ fontWeight: "bold", textTransform: "capitalize" }}>
              No questions selected for deletion.
            </span>
          </div>
        </div>
      );
      setTimeout(() => setIsMessageBoxVisible(false), 3000);
      return;
    }

    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span>
            Are you sure you want to delete {selectedRows.length} selected
            question(s)?
          </span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px", justifyContent: "center" }}
        >
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              style={{ width: "72px" }}
              onClick={confirmDelete}
            >
              Proceed
            </button>
            <button
            style={{ width: "62px" }}
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };

  // const confirmDelete = async () => {
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Deleting selected questions, please wait...</span>
  //       </div>
  //     </div>
  //   );

  //   const selectedQuestionIds = selectedRows.map((index) => data[index][7]);
  //   console.log(selectedQuestionIds);

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/delete-parse-ques-operator/?username=${userName}&client_branch_id=${clientBranchId}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(selectedQuestionIds),
  //       }
  //     );

  //     if (response.ok) {
  //       const responseData = await response.json();
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span>
  //               {responseData.message ||
  //                 "Selected questions deleted successfully!"}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(SuccessImg);

  //       setData((prevData) =>
  //         prevData.filter((_, index) => !selectedRows.includes(index))
  //       );

  //       setSelectedRows([]);
  //     } else {
  //       const errorData = await response.json();
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span style={{ color: "red", fontWeight: "bold" }}>
  //               Failed to delete questions:{" "}
  //               {errorData.message || "Unknown error."}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error deleting questions:", error);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span style={{ color: "red", fontWeight: "bold" }}>
  //             Failed to delete questions. Please try again later.
  //             <br />
  //             {error.message}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //   } finally {
  //     setTimeout(() => setIsMessageBoxVisible(false), 3000);
  //   }
  // };

  const confirmDelete = async () => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Deleting selected questions, please wait...</span>
        </div>
      </div>
    );

    const selectedQuestionIds = selectedRows.map((index) => data[index][7]); // Extracting question IDs
    console.log(selectedQuestionIds);

    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/delete-parse-ques-operator/?username=${userName}&client_branch_id=${clientBranchId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedQuestionIds),
        }
      );

      const responseData = await response.json();

      if (response.ok && responseData.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{responseData.message}</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg)

        // Remove deleted questions from the state
        // setData((prevData) =>
        //   prevData.filter((_, index) => !selectedRows.includes(index))
        // );
        // setSelectedRows([]);

        setTimeout(() => {
          setData((prevData) =>
            prevData.filter((_, index) => !selectedRows.includes(index))
          );
          setSelectedRows([]);
          setIsMessageBoxVisible(false);
        }, 1000);

      } else if (responseData.status === 403 && responseData.error === "QuestionReviewed") {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                {responseData.message}
              </span>
            </div>
          </div>
        );
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                Failed to delete questions: {responseData.message || "Unknown error."}
              </span>
            </div>
          </div>
        );
      }
    } catch (error) {
      console.error("Error deleting questions:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              Failed to delete questions. Please try again later.
              <br />
              {error.message}
            </span>
          </div>
        </div>
      );
    } finally {
      setTimeout(() => setIsMessageBoxVisible(false), 3000);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="input-top-tc"
              onChange={handleSearch}
            />
            <img src={searchicon} className="search-icon-tc" alt="search" />
          </div> */}
          <div style={{ display: "flex", alignItems: "center", border: "1px solid #6A6A6A", overflow: "hidden" }}>
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div style={{ width: "1px", height: "24px", backgroundColor: "#2F2E40", margin: "0 4px" }}></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
            </div>
          <div style={{ textAlign: "end" }}>
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        // className="row-tc"
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          // className="col-cs2-tc"
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          // onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "25px", width: "25px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
            cursor: data.length > 0 ? "pointer" : "not-allowed",
          }}
          onClick={() => setIsModalVisible(true)}
        >
          <img
            src={FileExport}
            style={{ height: "25px", width: "25px" }}
            alt="export"
            onClick={() => setIsModalVisible(true)}
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>
            Export
          </span>
        </div> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
            cursor: data.length > 0 ? "pointer" : "not-allowed",
          }}
          onClick={handleDeleteClick}
        >
          <img
            src={DeleteIcon}
            style={{ height: "25px", width: "25px" }}
            alt="export"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Delete</span>
        </div>
        <div
          // className="col-tc"
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px"
        }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span style={{ marginLeft: "4px", color: "#2F2E40", marginRight: "14px", fontSize: "14px"}}>
            Column Selection
          </span>
          {isColumnDivVisible && (
            <>
              <div className="arrow-up-tc"></div> {/* Add the arrow */}
              <div className="popupColumn-tc" ref={columnDropdownRef}>
                {headers.map((column, index) => (
                  <div
                    key={index}
                    onClick={() => handleColumnSelection(column)}
                  >
                    <input
                      type="checkbox"
                      id={`column-${index}`}
                      name="columnSelection"
                      value={column}
                      className="square-checkbox-tc"
                      checked={visibleColumns.includes(column)}
                      readOnly
                    />
                    <label
                      htmlFor={`column-${index}`}
                      // style={{ marginLeft: "10px" }}
                    >
                      {column}
                    </label>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {data.length > 0 ? (
        <>
          <table className="table-tc" style={{ width: "100%" }}>
            <thead>
              <tr>
                {visibleColumns.map((heading, index) => (
                  <td
                    className="Heading-tc"
                    key={index}
                    style={{
                      textAlign: "center",
                      cursor: "pointer",
                      minWidth: "160px",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "left",
                        justifyContent: "left",
                      }}
                    >
                      {index === 0 && (
                        <input
                          type="checkbox"
                          className="delete-question-checkbox-dqc"
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                        />
                      )}
                      {heading}
                      <img
                        onClick={() => handleSort(heading)}
                        src={updown}
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "5px",
                        }}
                        alt="sort"
                      />
                    </span>
                  </td>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                >
                  {visibleColumns.map((column, cellIndex) => (
                    <td
                      key={cellIndex}
                      style={{ textAlign: "left", color: "#6A6A6A" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {/* {cellIndex === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={selectedRows.includes(rowIndex)}
                            onChange={() => handleRowSelect(rowIndex)}
                          />
                        )} */}
                        {cellIndex === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={selectedRows.includes(rowIndex)}
                            onChange={() => handleRowSelect(rowIndex)}
                          />
                        )}
                        {headers.indexOf(column) === 0 ? (
                          <Link
                            style={{
                              color: "#337ab7",
                              textDecoration: "none",
                              fontWeight: "500",
                            }}
                            to={`/ques_dashboard?setId=${encodeURIComponent(
                              setId
                            )}`}
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedQuestion(row);
                              setIsQuesModalVisible(true);
                            }}
                          >
                            {row[headers.indexOf(column)]}
                          </Link>
                        ) : (
                          <span className="question-text-cell">
                            {renderQuestionText(row[headers.indexOf(column)])}
                          </span>
                        )}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              style={{
                position: "absolute",
                left: "-29px",
                height: "40px",
                width: "30px",
                color: "white",
                border: "none",
                fontSize: "20px",
                fontWeight: "700",
                borderRadius: "5px 0px 0px 5px",
              }}
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                style={{
                  width: "30%",
                  height: "32px",
                  borderRadius: "5px",
                  border: "2px solid #2F2E40",
                  fontSize: "16px",
                  fontWeight: "700",
                  backgroundColor: "white",
                  marginRight: "8px",
                  marginTop: "10px",
                }}
                onClick={handleApplyFilter}
              >
                APPLY
              </button>
            </div>
            <input
              type="text"
              placeholder="Enter Average Run Time"
              value={filterRunTime}
              onChange={handleFilterRunTimeChange}
            />
          </div>
        </div>
      )}

      {isModalVisible && data.length > 0 && (
        <div>
          <div className="arrow-up-tc-QB" style={{ top: "275px" }}></div>
          <div className="arrow-up-tc-QB-model" style={{ top: "280px" }}>
            <div className="modal-content-tc">
              <h3>Select Export File Type</h3>
              <button
                onClick={() => [
                  handleExport("excel"),
                  setIsModalVisible(false),
                ]}
              >
                Excel
              </button>
              <button
                onClick={() => [handleExport("csv"), setIsModalVisible(false)]}
              >
                CSV
              </button>
              <button
                onClick={() => [handleExport("pdf"), setIsModalVisible(false)]}
              >
                PDF
              </button>
              <button onClick={() => setIsModalVisible(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {isQuesModalVisible && selectedQuestion && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
        >
          <div className="modal-content-all-question">
            <button
              className="modal-close-button"
              onClick={() => setIsQuesModalVisible(false)}
            >
              X
            </button>
            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  backgroundColor: "#D6D6D6",
                  padding: "8px",
                }}
              >
                QUESTION NO # {selectedQuestion[0]}
              </p>
            </div>
            <div
              className="modal-question-options"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
                boxSizing: "border-box",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <p>Question Type: {selectedQuestion[2]}</p>
              <ul>
                <div>
                  <span
                    style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      marginRight: "2px",
                    }}
                  >
                    Question<span style={{ fontSize: "18px" }}>:</span>
                  </span>
                  <span style={{ fontSize: "25px", marginLeft: "3px" }}>
                    {renderQuestionTextModel(selectedQuestion[1])}
                  </span>
                </div>
                {/* {selectedQuestion[6]?.map((option, index) => (
                  <li key={index}>
                    <div className="toggle-radio">
                      <input
                        type="radio"
                        id={`option-${index}`}
                        checked={option.option_correct_flag}
                        onChange={() => { }}
                        style={{ minWidth: "20px" }}
                      />
                      <div>{renderQuestionTextModel(option.option_text)}</div>
                    </div>
                  </li>
                ))} */}
                {selectedQuestion[6]?.map((option, index) => (
                  <li key={index}>
                    <div className="toggle-radio">
                      <input
                        type="radio"
                        id={`option-${index}`}
                        checked={option.option_correct_flag}
                        onChange={() => {}}
                        style={{ minWidth: "20px" }}
                      />
                      <div>
                        {renderQuestionTextModel(
                          option.option_text,
                          expandedStates,
                          (key) => toggleImage(key)
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DeleteQuestionDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [setDetails, setSetDetails] = useState({
    setName: location.state?.setName || "",
    course: location.state?.course || "",
    subject: location.state?.subject || "",
    createdBy: location.state?.createdBy || "",
    createdOn: location.state?.createdOn || "",
    status: location.state?.status || "",
    setId: location.state?.setId || "",
  });

  const [expandedStates, setExpandedStates] = useState({});
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const accessToken = localStorage.getItem("other");

  const toggleImage = (key) => {
    setExpandedStates((prevStates) => ({
      ...prevStates,
      [key]: !prevStates[key], // Toggle based on the unique key
    }));
  };

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const headers = [
    "Question #",
    "Question Text",
    "Question Type",
    "Modified By",
    "Modified On",
    "Status",
  ];

  // const preprocessLatex = (text) => {
  //   // Replace invalid characters or patterns
  //   return text
  //     .replace(/amp;/g, "&") // Example: Fix improperly encoded ampersands
  //     .replace(/\s+/g, " ") // Remove extra spaces
  //     .trim();
  // };

  // const renderLatex = (latexText) => {
  //   try {
  //     const processedText = preprocessLatex(latexText);
  //     return <Latex>{processedText}</Latex>;
  //   } catch (error) {
  //     console.error("Invalid LaTeX syntax:", latexText, error);
  //     return <span>{latexText}</span>; // Render plain text as fallback
  //   }
  // };

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "50px", height: "45px" }}
          />
        );
      } else {
        return (
          <span key={index}>
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const renderQuestionTextModel = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return (
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {questionSegments.map((segment, index) => {
          if (segment.startsWith("imgsrc=")) {
            const imageUrl = segment.replace("imgsrc=", "");
            const key = `${questionText}-${index}`;
            const isExpanded = expandedStates[key] || false;

            return (
              <img
                key={index}
                src={imageUrl}
                alt={`Question Image ${index}`}
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: isExpanded ? "450px" : "200px",
                  maxHeight: isExpanded ? "550px" : "250px",
                  objectFit: "contain",
                  margin: "0 5px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={() => toggleImage(key)}
              />
            );
          } else {
            return (
              <span key={index} style={{ margin: "0 5px" }}>
                <Latex>{segment}</Latex>
              </span>
            );
          }
        })}
      </div>
    );
  };

  useEffect(() => {
    if (reportDashboardData.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please Wait Loading The Data...</span>
          </div>
        </div>
      );
    } else {
      setIsMessageBoxVisible(false);
      setActiveImg(InterogativeImg);
    }
  }, [reportDashboardData]);

  const fetchDashboardData = async () => {
    try {
      if (!clientId || !clientBranchId) {
        console.error("Missing clientId or clientBranchId. Cannot fetch data.");
        return;
      }
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parsed-questions/?client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_id=${setDetails.setId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard data");
      }

      const data = await response.json();

      const formatDate = (dateString) => {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two-digit day
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      };

      const quesTypeMapping = {
        1: "Single correct",
        2: "Multi correct",
        3: "Fill in the blanks",
        4: "Boolean",
      };

      const statusMapping = {
        1: "Draft",
        2: "Initial Check Complete",
        3: "Submitted",
        4: "Reviewed",
        5: "Approved",
        6: "Rejected",
        7: "Deleted",
      };

      const transformedData = data?.map((ques) => [
        ques.ques_no,
        // <Latex>{ques.question_text}</Latex>,
        // renderLatex(ques.question_text),
        ques.question_text,
        quesTypeMapping[ques.ques_type],
        ques.initial_reviewed_by,
        formatDate(ques.initial_reviewed_on),
        statusMapping[ques.status],
        ques.options,
        ques.question_id,
      ]);
      setReportDashboardData(transformedData);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  // const handleDeleteClick = () => {
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Are you sure to delete the set "{setDetails.setId}"?
  //           <p>Deleting the set will delete all 36 question of this set.</p></span>
  //       </div>
  //       <div className="messagebox-insider2" style={{ display: "flex", gap: "10px" }}>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           style={{ width: "72px" }}
  //           onClick={() => { setIsMessageBoxVisible(false) }}>
  //           Proceed
  //         </button>
  //         <button
  //           className="messagebox-cancel-btn-ok"
  //           onClick={() => { setIsMessageBoxVisible(false) }}>
  //           OK
  //         </button>
  //       </div>
  //     </div>
  //   );
  // };

  const handleDeleteClick = () => {
    // console.log("Report Dashboard Data:", reportDashboardData);
    const totalQuestions = reportDashboardData.length;
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            Are you sure to delete the set "{setDetails.setId}"?
            <p>
              Deleting the set will delete all {totalQuestions} questions of
              this set.
            </p>
          </span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "72px" }}
            onClick={confirmDelete} // Proceed button triggers the delete operation
          >
            Proceed
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            style={{ width: "62px" }}
            onClick={() => {
              setIsMessageBoxVisible(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  // const confirmDelete = async () => {
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Deleting the set, please wait...</span>
  //       </div>
  //     </div>
  //   );

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/delete-parse-ques-operator/?username=${userName}&client_branch_id=${clientBranchId}&parse_ques_set_id=${setDetails.setId}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span>{data.message || "Set deleted successfully!"}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(SuccessImg);
  //       setTimeout(() => {
  //         navigate("/set_dashboard"); // Redirect to the dashboard after 2 seconds
  //       }, 2000);
  //     } else {
  //       const errorData = await response.json();
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span>
  //               Failed to delete the set:{" "}
  //               {errorData.message || "Unknown error."}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error deleting the set:", error);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>
  //             Failed to delete the set. Please try again later.
  //             <br />
  //             {error.message}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //   } finally {
  //     setTimeout(() => setIsMessageBoxVisible(false), 3000);
  //   }
  // };

  const confirmDelete = async () => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Deleting the set, please wait...</span>
        </div>
      </div>
    );

    try {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/delete-parse-ques-operator/?username=${userName}&client_branch_id=${clientBranchId}&parse_ques_set_id=${setDetails.setId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok && data.status === 200) {
        // Deletion successful, show success message and navigate
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{data.message}</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setTimeout(() => {
          navigate("/set_dashboard"); // Redirect to dashboard after 2 seconds
        }, 2000);
      } else if (data.status === 403 && data.error === "FacultyReviewPending") {
        // Deletion blocked due to pending review, show message and do not navigate
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                {data.message ||
                  "This set cannot be deleted as some questions are under review."}
              </span>
            </div>
          </div>
        );
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>
                Failed to delete the set: {data.message || "Unknown error."}
              </span>
            </div>
          </div>
        );
      }
    } catch (error) {
      console.error("Error deleting the set:", error);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>
              Failed to delete the set. Please try again later.
              <br />
              {error.message}
            </span>
          </div>
        </div>
      );
    } finally {
      setTimeout(() => setIsMessageBoxVisible(false), 3000);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        className=""
    
      >
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Question Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={() => navigate("/set_dashboard")}
            >
              CANCEL
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={() =>
                navigate(
                  `/question_review?setId=${setDetails.setId}&setName=${setDetails.setName}`
                )
              }
            >
              REVIEW
            </button>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                width: "180px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleDeleteClick}
            >
              DELETE THIS SET
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter Questions. Export a list of question or search
          for a question. When searching, enter at least two characters in the
          search field.
        </p>
        <div className="set-data-container">
          <div className="set-data-columns">
            <p>Set Name: {setDetails.setName}</p>
            <p>Course: {setDetails.course}</p>
            <p>Subject: {setDetails.subject}</p>
          </div>
          <div className="set-data-columns" style={{ marginRight: "35%" }}>
            <p>Created By: {setDetails.createdBy}</p>
            <p>Created On: {setDetails.createdOn}</p>
            <p>Status: {setDetails.status}</p>
          </div>
        </div>
        <div>
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            handleDeleteClick={handleDeleteClick}
            setId={setDetails.setId}
            renderQuestionTextModel={renderQuestionTextModel}
            expandedStates={expandedStates}
            toggleImage={toggleImage}
            setIsMessageBoxVisible={setIsMessageBoxVisible}
            setMessageBox={setMessageBox}
            setActiveImg={setActiveImg}
            setData={setReportDashboardData}
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteQuestionDashboard;
